import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  user-select: none;
`;

export const DropdownContent = styled.div<{ visible: boolean }>`
  position: absolute;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0px 3px 6px 0px rgba(51, 51, 51, 0.16);
  z-index: 9999;
  top: calc(100% + 4px);
  right: 0;
  min-width: 191px;
  display: ${({ visible }) => (visible ? "block" : "none")};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0;
`;

export const MenuItem = styled.div<{
  highlighted?: boolean;
  disabled?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  cursor: pointer;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.athensGray};
  background-color: ${({ highlighted, theme }) =>
    highlighted ? theme.colors.aquaHaze : theme.colors.white};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  &:last-child {
    border-bottom: none;
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }

  &:hover {
    background-color: ${({ theme }) => theme.colors.aquaHaze};
  }

  span {
    color: ${({ highlighted, theme }) =>
      highlighted ? theme.colors.denim : theme.colors.shuttleGray};
  }

  svg {
    opacity: 0.6;
    width: 16px;
    height: 16px;
  }
`;
